import { Provider } from '@fruitful/types';

import { isEmpty } from '../../misc';
import {
    FruitfulCustomIcon,
    type FruitfulCustomIconSize,
} from '../icons/FruitfulCustomIcon';
import {
    DEFAULT_COLOR,
    FRUITFUL_ICON_KEY,
} from '../icons/FruitfulCustomIconDefaults';
import { InstitutionLogo } from './InstitutionLogo';

const FRUITFUL_INSTITUTION_NAME = 'Fruitful';

interface LogoProps {
    institutionName: string;
    logo?: string;
    size?: FruitfulCustomIconSize;
    showShadow?: boolean;
    provider?: Provider;
}

export const HolisticAccountLogo = ({
    institutionName,
    logo,
    size,
    showShadow,
    provider,
}: LogoProps) => {
    // Logo is either a link to an svg for external institutions, or <icon>:<color> for custom Fruitful account icons
    if (institutionName === FRUITFUL_INSTITUTION_NAME) {
        const isFruitfulInvestmentAccount = provider === Provider.APEX;
        let [icon, color] = (logo ?? '').split(':');

        icon = !isEmpty(icon) ? icon : FRUITFUL_ICON_KEY; // If a fruitful account doesn't have an icon, use this for the Fruitful logo
        color = !isEmpty(color)
            ? color
            : isFruitfulInvestmentAccount
              ? 'peach'
              : DEFAULT_COLOR;

        return (
            <FruitfulCustomIcon
                icon={icon}
                color={color}
                size={size}
                showShadow={showShadow}
                useAltColors={isFruitfulInvestmentAccount}
            />
        );
    }

    return <InstitutionLogo logo={logo} size={size} showShadow={showShadow} />;
};
